<template lang='pug'>
  v-card.mt-0.pt-0
    v-btn.fixed-back-button(dark="" small text @click="returnTo()" color="#fff")
      v-icon( color="#fff" size="25") mdi-chevron-left
    v-dialog( persistent :value='updateItemDialogCollab'  max-width='800px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        update-collab(:model ='user' @close="updateItemDialogCollab=false")
    <!-- delete -->
    v-dialog(v-model='confirmationDialog' width="500px" persistent)
      v-card
        v-card-title
          | Eliminar {{typeTranslate()}}
          v-spacer
            v-icon(aria-label="Close" @click="confirmationDialog = false")
              | mdi-close
        v-card-text.body-1.text-center
          | ¿Esta seguro de eliminar este {{typeTranslate()}}?
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn(color='red darken-1', flat='', @click.native='deleteItem(user)') Si, proceder
    v-dialog( persistent  :value='clientsDialog'  max-width='800px'   transition="dialog-bottom-transition" )
        ClientsForm(v-if='clientsDialog' :model="currentClient" @close="clientsDialog = false")
    v-dialog( persistent :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
        div(style ='position:relative; height: 100%;')
            update-provider(:model ='user' v-if='updateItemDialog' @close="updateItemDialog=false")
    v-img(style="position: relative;" :src="getImage(user.pictures && user.pictures.imageInput1 ? user.pictures.imageInput1 : userPlaceholder)"  height="300px" dark="")
        v-row
        v-col(cols="12").mt-4
            v-btn(absolute style="right: 1rem" dark="" fab small @click="editItem(user)" color="#009da5")
              v-icon() mdi-pencil
            v-btn(absolute  style="right: 5rem" dark fab small @click="openDeleteDialog(user)"  color="#009da5")
              v-icon() mdi-delete
        span.shop__title--mobile {{type === 'provider' || type === 'client' ? user.name : user.displayName}}
    v-list(two-line="")
        v-list-item(v-if="type === 'provider' || type === 'client'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-phone
            v-list-item-content
                v-list-item-title {{user.phone}}
                v-list-item-subtitle Teléfono
        v-divider(inset="")
        v-list-item(v-if="type === 'provider'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-account
            v-list-item-content
                v-list-item-title {{user.seller}}
                v-list-item-subtitle Nombre del vendedor
        v-divider(inset="")
        v-list-item(v-if="type === 'provider'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-pound
            v-list-item-content
                v-list-item-title {{user.nit}}
                v-list-item-subtitle NIT
        v-divider(inset="")
        v-list-item(v-if="type === 'client'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-account
            v-list-item-content
                v-list-item-title {{user.identification}}
                v-list-item-subtitle C.C.
        v-divider(inset="")
        v-list-item(v-if="type === 'client'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-account
            v-list-item-content
                v-list-item-title {{user.email}}
                v-list-item-subtitle Correo
        v-divider(inset="")
        v-list-item(v-if="type === 'client'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-account
            v-list-item-content
                v-list-item-title {{user.direction}}
                v-list-item-subtitle Dirección
        v-list-item(v-if="type === 'collaborator'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-account
            v-list-item-content
                v-list-item-title {{user.email}}
                v-list-item-subtitle Correo
        v-list-item(v-if="type === 'collaborator'")
            v-list-item-icon
                v-icon(color="primary")
                    | mdi-account
            v-list-item-content
                v-list-item-title {{user.role}}
                v-list-item-subtitle Rol
    v-card(v-if="type === 'collaborator'")
        v-card-title
          | Metricas del Colaborador
        v-card-text.body-1.text-center
          v-row.justify-center(class="pa-3")
            v-col(:cols="isMobile ? '6' : '2'")
              v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
                template(v-slot:activator='{ on }')
                  v-btn.main-btn-gradient(small color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
                    v-icon mdi-calendar
                    | filtrar por fechas
                v-card(style="border:3px solid #3cbbc2;").pa-2
                  date-filter(@closeMenu="filterSummary($event)" :currentType='currentType',)
            h2.d-flex.align-center(class='ml-9' v-if="!isMobile" style="margin: 0 !important;") {{from === '' ? 'En los últimos 7 días ha realizado las siguientes ventas: ' : 'Desde ' + from + ' hasta ' + to + ' ha realizado las siguientes ventas: '}}
            v-col(sm='6' lg='3' v-if="isMobile")
              h5(class='ml-9' style="margin: 0 !important;") {{from === '' ? 'En los últimos 7 días ha realizado las siguientes ventas: ' : 'Desde ' + from + ' hasta ' + to + ' ha realizado las siguientes ventas: '}}
            v-spacer(v-if="!isMobile")
            v-row.justify-center.my-2.align-center(:style="isMobile ? '' : 'display: flex;align-self: center;'")
              v-btn.main-btn-gradient(small style="height: 48px;" @click="filterSummary(null)")
                v-icon mdi-refresh
              | Actualizar a los últimos 7 días
            //- v-btn.main-btn-gradient(@click="filterSummary(null)" small color='#008E95' :style="isMobile ? '' : 'display: flex;align-self: center;'").mx-2
              v-icon(left='' small) mdi-refresh
              p
            .text-center(style="display:flex; align-items:flex-start;").mt-2
          p En total realizó {{totalAmountSalesCollabs}} ventas
          v-skeleton-loader.mx-auto(:transition='transition' type='card' v-if='loading')
          LineChart(v-else :chart-data='collaboratorData' :options="optionsCharts")
</template>

<script>
  import Swal from 'sweetalert2'
  import userPlaceholder from '@/assets/user.png'
  import CreateProvider from '@/views/custom/CreateProvider.vue'
  import UpdateProvider from '@/views/custom/UpdateProvider'
  import ClientsForm from '@/components/custom/forms/ClientsForm'
  import UpdateCollab from '@/views/custom/UpdateUser'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import LineChart from '@/components/custom/charts/LineChart'
  import moment from 'moment'

  export default {
    name: 'UserDetails',
    components: {
      LineChart,
      DateFilter: DateFilter,
      CreateProvider: CreateProvider,
      UpdateProvider: UpdateProvider,
      ClientsForm: ClientsForm,
      UpdateCollab: UpdateCollab,
    },
    props: {
      type: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        userPlaceholder,
        updateItemDialog: false,
        confirmationDialog: false,
        currentClient: {},
        clientsDialog: false,
        updateItemDialogCollab: false,
        menu: false,
        currentType: 'loadFilteredSummary',
        from: '',
        to: '',
        loading: false,
        collaboratorData: {
          labels: [],
          datasets: [],
        },
        totalAmountSalesCollabs: 0,
        transition: 'scale-transition',
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      user () {
        const vm = this
        if (vm.type === 'provider') {
          return vm.$store.getters['providers/getCurrentItem']
        } else if (vm.type === 'client') {
          return vm.$store.getters['clients/getCurrentItem']
        } else {
          return vm.$store.getters['admins/getCurrentItem']
        }
      },
      optionsCharts () {
        return {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
    },
    created () {
      const vm = this
      if (vm.type === 'collaborator') {
        vm.getCollaboratorsMetrics(null, 'week')
      }
    },
    methods: {
      typeTranslate () {
        const vm = this
        if (vm.type === 'provider') {
          return 'proveedor'
        } else if (vm.type === 'client') {
          return 'cliente'
        } else {
          return 'colaborador'
        }
      },
      async filterSummary (dates) {
        const vm = this
        let preset = 'week'
        if (dates) {
          vm.menu = false
          vm.from = moment(dates.from).format('DD-MM-YYYY')
          vm.to = moment(dates.to).format('DD-MM-YYYY')
          const momentFrom = moment(dates.from)
          const momentTo = moment(dates.to)
          const differenceInDays = momentTo.diff(momentFrom, 'days')
          // este preset es para los labels. No es para calcular fechas
          if (differenceInDays === 1) {
            preset = 'today'
          } else if (differenceInDays <= 7) {
            preset = 'week'
          } else if (differenceInDays <= 31) {
            preset = 'month'
          } else {
            preset = 'year'
          }
        } else {
          vm.from = ''
          vm.to = ''
        }
        vm.getCollaboratorsMetrics(dates, preset)
      },
      getCollaboratorsMetrics (dates, preset) {
        const vm = this
        vm.loading = true
        const collabs = {
          dates: dates,
          userId: vm.$store.state.users.user.uid,
          shopId: '',
          colabId: vm.user.id,
          preset: preset,
        }
        vm.$store.dispatch('summary/summaryByCollaborator', collabs).then(res => {
          if (res.data.collaborators.length > 0) {
            vm.collaboratorData.labels = Object.keys(res.data.resultsCost[0])
            vm.totalAmountSalesCollabs = res.data.amountSales
            vm.collaboratorData.datasets = []
            const collaborator = res.data.collaborators[0]
            const sales = res.data.resultsCost[0]
            vm.collaboratorData.datasets.push({
              label: collaborator.email,
              data: Object.values(sales),
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
            })
            vm.$forceUpdate()
          } else {
            vm.collaboratorData.labels = []
            vm.collaboratorData.datasets = []
          }
          vm.loading = false
        })
      },
      returnTo () {
        const vm = this
        if (vm.type === 'provider') {
          vm.$router.replace('/dashboard/providers')
        } else if (vm.type === 'client') {
          vm.$router.replace('/dashboard/clients')
        } else {
          vm.$router.replace('/dashboard/collaborators')
        }
      },
      getImage (url) {
        if (url === '') {
          return '@/assets/logo-2-w-small.png'
        } else {
          return url
        }
      },
      editItem (item) {
        const vm = this
        if (vm.type === 'provider') {
          vm.$store.dispatch('providers/setCurrentItem', { context: 'properties', id: item.id }).then(function () {
            vm.updateItemDialog = true
          })
        } else if (vm.type === 'client') {
          vm.currentClient = item
          vm.clientsDialog = true
        } else {
          this.$store.dispatch('admins/setCurrentItem', { context: 'properties', id: item.id }).then(function () {
            vm.updateItemDialogCollab = true
          })
        }
      },

      openDeleteDialog (item) {
        const vm = this
        vm.currentItemId = item
        let title = 'Eliminar '
        if (vm.type === 'provider') {
          title = title + ' Proveedor'
        } else if (vm.type === 'client') {
          title = title + ' Cliente'
        } else {
          title = title + ' Colaborador'
        }
        Swal.fire({
          title: title,
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteItem(vm.currentItemId)
          }
        })
      },
      deleteItem (item) {
        const vm = this
        // console.log(item)
        if (vm.type === 'provider') {
          vm.$store.dispatch('providers/deleteItem', item).then(function () {
            vm.confirmationDialog = false
            vm.returnTo()
          },
          ).catch(function () {
            vm.confirmationDialog = false
          })
        } else if (vm.type === 'client') {
          this.$store.dispatch('clients/deleteClient', item).then(function () {
            vm.confirmationDialog = false
            vm.returnTo()
          },
          ).catch(function () {
            vm.confirmationDialog = false
            // console.log('error')
          })
        } else {
          vm.$store.dispatch('admins/deleteItem', item)
            .then(function () {
              vm.confirmationDialog = false
              vm.returnTo()
            },
            ).catch(function () {
              vm.confirmationDialog = false
            })
        }
      },

    },
  }
</script>
<style lang="scss">
    .shop {
      &__title {
        &--mobile {
          position: absolute;
          bottom: 0;
          left: 1rem;
          color: #009da5;
          font-size: 2rem;
          font-weight: bold;
          padding: 10px;
          text-shadow: 3px 1px black;
        }
      }
    }
</style>
